import React from 'react'
import logoImage from '@/images/logo/logo.png'

export interface LogoProps {
    /** Size variant of the logo */
    size?: 'sm' | 'md' | 'lg' | 'xl'
    /** Whether to show the SideGO text alongside the logo */
    showText?: boolean
    /** Custom className for the container */
    className?: string
    /** Whether to show the logo on white background (default) or plain */
    variant?: 'default' | 'plain'
    /** Text color for the SideGO text */
    textColor?: string
    /** Custom background color for the logo container */
    backgroundColor?: string
}

const Logo: React.FC<LogoProps> = ({
    size = 'md',
    showText = true,
    className = '',
    variant = 'default',
    textColor = 'text-gray-900 dark:text-white',
    backgroundColor = 'bg-transparent'
}) => {
    const sizeClasses = {
        sm: {
            container: 'h-8 w-8',
            image: 'h-6 w-6',
            text: 'text-sm font-poppins font-bold ml-1.5'
        },
        md: {
            container: 'h-10 w-10',
            image: 'h-8 w-8',
            text: 'text-xl font-poppins font-bold ml-2'
        },
        lg: {
            container: 'h-14 w-14',
            image: 'h-12 w-12',
            text: 'text-2xl font-poppins font-bold ml-2.5'
        },
        xl: {
            container: 'h-16 w-16',
            image: 'h-14 w-14',
            text: 'text-3xl font-poppins font-bold ml-3'
        }
    }

    const currentSize = sizeClasses[size]

    const containerClasses = variant === 'default'
        ? `${currentSize.container} ${backgroundColor} rounded-full flex items-center justify-center `
        : `${currentSize.container} flex items-center justify-center`

    return (
        <div className={`flex items-center ${className}`}>
            <div className={containerClasses}>
                <img
                    src={logoImage}
                    alt="SideGO Logo"
                    className={`${currentSize.image} object-contain`}
                />
            </div>
            {showText && (
                <span className={`${currentSize.text} ${textColor}`}>
                    SideGO
                </span>
            )}
        </div>
    )
}

export default Logo